import { useTranslations } from 'use-intl'

import { Reveal } from '@/components/ui/reveal'

/**
 * A standalone pull-quote below the client logos. Opening and closing quote
 * marks sit at the block's top-left and bottom-right in the brand blue; the
 * quote body is muted and the closing line lands back in primary.
 */
export function QuoteSection() {
  const t = useTranslations('home.quote')

  return (
    <section className="mb-24 border-y border-muted px-6 py-16">
      <Reveal className="relative mx-auto max-w-4xl">
        <span
          aria-hidden
          className="absolute -top-6 left-0 font-serif text-6xl leading-none text-primary"
        >
          &ldquo;
        </span>
        <blockquote className="px-8 text-center text-2xl font-semibold leading-snug sm:text-3xl">
          <span className="text-secondary-foreground">{t('lead')}</span>
          <span className="mt-2 block text-primary">{t('emphasis')}</span>
        </blockquote>
        <span
          aria-hidden
          className="absolute -bottom-10 right-0 font-serif text-6xl leading-none text-primary"
        >
          &rdquo;
        </span>
      </Reveal>
    </section>
  )
}
